<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.3536 8.10636C13.1583 7.9111 12.8417 7.9111 12.6464 8.10636L9.11091 11.6419C8.91565 11.8372 8.91565 12.1537 9.11091 12.349L12.6464 15.8845C12.8417 16.0798 13.1583 16.0798 13.3536 15.8845C13.5488 15.6893 13.5488 15.3727 13.3536 15.1774L10.1716 11.9954L13.3536 8.81347C13.5488 8.61821 13.5488 8.30162 13.3536 8.10636Z" fill="currentcolor" />
  </svg>
</template>
